const BASE_URL = 'https://d2d0vwk3ealx06.cloudfront.net/data';
import stationsData from '../assets/data/stations.json';

export interface Station {
  title: string;
  value: string;
  routeValue: string;
  isHeader?: boolean;
}

const createStationValue = (name: string): string => {
  return name.replace(/\s+/g, '+') + '_combined.json.gz';
};

const createRouteValue = (name: string): string => {
  return name.replace(/\s+/g, '+');
};

export const stations: Station[] = Object.entries(stationsData).flatMap(([state, stateStations]) => [
  { title: state, value: '', routeValue: '', isHeader: true },
  ...stateStations.map(station => ({
    title: station,
    value: createStationValue(station),
    routeValue: createRouteValue(station)
  }))
]);

export const getTextStationValue = (stationValue: string): string => {
  return stationValue.replace('combined.json.gz', 'calculated_text.json');
};

export const fetchStationTextData = async (stationValue: string) => {
  try {
    const textValue = getTextStationValue(stationValue);
    const response = await fetch(`${BASE_URL}/${textValue}`);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching station text data:', error);
    throw error;
  }
};

export const fetchStationData = async (stationValue: string) => {
  try {
    const response = await fetch(`${BASE_URL}/${stationValue}`);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Get the response as a blob
    const blob = await response.blob();
    
    // Create a decompression stream
    const ds = new DecompressionStream('gzip');
    
    // Create a stream from the blob and pipe it through the decompression stream
    const decompressedStream = blob.stream().pipeThrough(ds);
    
    // Convert the decompressed stream to text
    const decompressedBlob = await new Response(decompressedStream).blob();
    const text = await decompressedBlob.text();
    
    // Replace NaN with null before parsing JSON
    const cleanedText = text.replace(/:\s*NaN/g, ': null');
    return JSON.parse(cleanedText);
  } catch (error) {
    console.error('Error fetching station data:', error);
    throw error;
  }
};
